import { Field, Form, HousingAlert, Sender } from "@garantidos/components"

import Button from "@mobi/ds/components/Button"
import Text from "@mobi/ds/components/Text"

import linksEnum from "pages/Proposal/constants/linksEnum"

import useLeadAddress from "./hooks"

import "./style.scss"

const LeadAddress = () => {
  const {
    handlePrevStep,
    onSubmitCallback,
    fields,
    form,
    onCepResult,
    errorMessage,
    setErrorMessage,
    isLoading
  } = useLeadAddress()
  const { isValid } = form
  const { cep, street, state, city, neighborhood, number, complement } = fields

  return (
    <div className="proposalLeadAddress">
      <div className="proposalLeadAddress__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <h1 className="proposalLeadAddress__title">endereço residencial</h1>
        <Text p className="proposalLeadAddress__text">
          Conte-nos um pouco sobre onde mora atualmente:
        </Text>
        <Form onSubmit={onSubmitCallback} form={form}>
          <Field
            field={cep}
            onResult={onCepResult}
            form={form}
            data-testid={cep.name}
            disabled={isLoading}
          />
          <Button
            variant="action"
            tagName="a"
            href={linksEnum.BUSCA_CEP}
            target="_blank"
            rel="noreferrer"
            className="proposalLeadAddress__link"
          >
            não sabe o CEP?
          </Button>
          <Field
            field={street}
            form={form}
            data-testid={street.name}
            disabled={isLoading}
          />
          <Field
            field={state}
            form={form}
            data-testid={state.name}
            disabled={isLoading}
          />
          <Field
            field={city}
            form={form}
            data-testid={city.name}
            disabled={isLoading}
          />
          <Field
            field={neighborhood}
            form={form}
            data-testid={neighborhood.name}
            disabled={isLoading}
          />
          <Field
            field={number}
            form={form}
            data-testid={number.name}
            disabled={isLoading}
          />
          <Field
            field={complement}
            form={form}
            required={false}
            data-testid={complement.name}
            disabled={isLoading}
          />
          <Sender
            onPrev={handlePrevStep}
            isNextDisabled={!isValid}
            data_testid="submit"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default LeadAddress
